import DeveloperMetricsStore from "./DeveloperMetrics/DeveloperMetricsStore";

/**
 * View stores for the Reports view group. Spread into `appStores` in
 * src/appStoresConfig.ts. NOT "developerMetricsStore" — that key belongs to the
 * `developer-metrics` ServiceStore this view reads from.
 */
const reportsStoreList = [
  { name: "developerMetricsViewStore", store: DeveloperMetricsStore },
];

export default reportsStoreList;
